/* eslint-disable react/prop-types */
import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import {TextField as Core} from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

// Imports Styles
import style from "./style";
import { VpnIcon, EmailIcon } from '../../assets/svg'
/**
 * TextField Component
 * @param {*} props
 */
function TextFieldComponent({ id, name, autoFocus, placeholder, multiline, autoComplete, margin, rows, variant, fullWidth,withImage,imageType, passShow, ...rest }) {

   // ref
  const searchBoxRef = useRef()
 
  const fieldImage=()=>{
    return withImage ? 
    imageType==='uemail'? <InputAdornment position="start"><EmailIcon /></InputAdornment> :
    imageType==='passwd'? <InputAdornment position="start"><VpnIcon /></InputAdornment> : ""
    :""
  }

  return (
    <Core
      id={id}
      placeholder={placeholder}
      name={name}
      multiline={multiline}
      autoComplete={autoComplete}
      margin={margin}
      autoFocus={autoFocus}
      rows={rows}
      variant={variant}
      fullWidth={fullWidth}
      InputProps={{
            startAdornment: fieldImage(),
            endAdornment: passShow ? <InputAdornment position="end"><Visibility className={"opacity0"} /></InputAdornment> : ''
          }}
      {...rest}
    />
  );
}

// default props
TextFieldComponent.defaultProps = {
  id: "",
  name: "",
  type: "text",
  autoComplete: "new-password",
  rows: "0",
  margin: "normal",
  variant: "outlined",
  fullWidth: true,
  withImage:false,
  passShow: false,
  autoFocus: false
};

// prop types
TextFieldComponent.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  rows: PropTypes.string,
  autoComplete: PropTypes.string,
  margin: PropTypes.string,
  variant: PropTypes.string,
  fullWidth: PropTypes.bool,
  withImage: PropTypes.bool,
  passShow: PropTypes.bool,
  autoFocus: PropTypes.bool
};

// export component
export const TextField = withStyles(style)(TextFieldComponent);
